import { ListStep as Step } from '../../utils';
import { Props as BaseProps } from '../Step';

export type Props = BaseProps<Step>;

export function ListStep(props: Props) {
  return <h1>List Step</h1>;
}
